// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2J9Wn","checkbox":"styles_checkbox__1dnAL"};